import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_601_27987)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.57142 20V12.4857C8.59373 11.0087 8.90728 9.55052 9.4941 8.19485C10.0809 6.83919 10.9295 5.61264 11.9911 4.58548C13.0528 3.55832 14.3067 2.75074 15.681 2.20902C17.0553 1.6673 18.523 1.40208 20 1.42856C21.477 1.40208 22.9447 1.6673 24.319 2.20902C25.6933 2.75074 26.9472 3.55832 28.0088 4.58548C29.0705 5.61264 29.9191 6.83919 30.5059 8.19485C31.0927 9.55052 31.4062 11.0087 31.4286 12.4857V20M25.7143 35C27.2298 35 28.6832 34.398 29.7549 33.3263C30.8265 32.2547 31.4286 30.8012 31.4286 29.2857V22.8571M25.7143 35C25.7143 35.9472 25.338 36.8556 24.6682 37.5254C23.9985 38.1951 23.09 38.5714 22.1428 38.5714H17.8571C16.9099 38.5714 16.0015 38.1951 15.3317 37.5254C14.662 36.8556 14.2857 35.9472 14.2857 35C14.2857 34.0528 14.662 33.1444 15.3317 32.4746C16.0015 31.8048 16.9099 31.4286 17.8571 31.4286H22.1428C23.09 31.4286 23.9985 31.8048 24.6682 32.4746C25.338 33.1444 25.7143 34.0528 25.7143 35ZM4.2857 15.7143H7.14284C7.52172 15.7143 7.88509 15.8648 8.153 16.1327C8.42091 16.4006 8.57142 16.764 8.57142 17.1428V25.7143C8.57142 26.0932 8.42091 26.4565 8.153 26.7244C7.88509 26.9923 7.52172 27.1428 7.14284 27.1428H4.2857C3.52794 27.1428 2.80121 26.8418 2.2654 26.306C1.72958 25.7702 1.42856 25.0435 1.42856 24.2857V18.5714C1.42856 17.8137 1.72958 17.0869 2.2654 16.5511C2.80121 16.0153 3.52794 15.7143 4.2857 15.7143ZM35.7143 27.1428H32.8571C32.4782 27.1428 32.1149 26.9923 31.847 26.7244C31.5791 26.4565 31.4286 26.0932 31.4286 25.7143V17.1428C31.4286 16.764 31.5791 16.4006 31.847 16.1327C32.1149 15.8648 32.4782 15.7143 32.8571 15.7143H35.7143C36.472 15.7143 37.1988 16.0153 37.7346 16.5511C38.2704 17.0869 38.5714 17.8137 38.5714 18.5714V24.2857C38.5714 25.0435 38.2704 25.7702 37.7346 26.306C37.1988 26.8418 36.472 27.1428 35.7143 27.1428Z",
      stroke: "#131212",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_601_27987" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hHh LpR fFf" }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _createVNode(_component_q_page_sticky, {
        style: {"z-index":"1000"},
        position: "bottom-right",
        offset: [18, 18]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            href: "https://t.me/masons_sup",
            round: "",
            fab: "",
            style: {"background-color":"#EDB94A"}
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}